import $ from 'jquery';

import './bootstrap';
import './openModalFromRandom';
import initializeAccordion from './accordion';
import initializeVideoOverlay from './video-overlay';
import initializeLiveStreamCountdown from './livestream-countdown';
import initializeSmoothScroll from './smooth-scroll';
import initializeBackTop from './back-top';
import initializeCountdown from './countdown';
import initializeCollapsibleContent from './collapsible-content';
import initializeSponsorAccordion from './sponsor-accordion';
import initializeNavigationAccordion from './accordion-navigation';
import initializeProgramm from './programm';
import initializeWorkshop from './workshop';
import initializeTimeline from './timeline';
import initializeTimelineAccordion from './timeline-collapse-item';
import initializeReadMore from "./read_more";

$(document).ready(() => {
  initializeAccordion();
  initializeVideoOverlay();
  initializeLiveStreamCountdown();
  initializeSmoothScroll();
  initializeBackTop();
  initializeCountdown();
  initializeCollapsibleContent();
  initializeSponsorAccordion();
  initializeNavigationAccordion();
  initializeProgramm();
  initializeWorkshop();
  initializeTimeline();
  initializeTimelineAccordion();
  initializeReadMore();
});
